import { render, staticRenderFns } from "./governmentServices.vue?vue&type=template&id=005c0764&scoped=true"
import script from "./governmentServices.vue?vue&type=script&lang=js"
export * from "./governmentServices.vue?vue&type=script&lang=js"
import style0 from "./governmentServices.vue?vue&type=style&index=0&id=005c0764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c0764",
  null
  
)

export default component.exports